import * as React from "react";
import { connect } from "react-redux";

import { listTopics, createTopic } from "../thunks";
import { RootState } from "../types";

import "./TopicsPage.css";
import { Topic } from "dialup";

interface IProps {
  topics: Topic[];

  doUpload: (topic: Topic, file: File) => any;
  refresh: () => any;
}

export class TopicsPage extends React.Component<IProps> {
  private input: HTMLInputElement | null;

  public componentWillMount() {
    this.props.refresh();
  }

  public render() {
    const { topics } = this.props;

    return (
      <div className="prompts-page">
        <input
          ref={this.onInputMount}
          onChange={this.onInputChange}
          type="file"
          accept="audio/mpeg"
          style={{ display: "none" }}
        />

        <div className="header sticky-top">
          <div className="sidebar-right">
            <button
              onClick={this.onUpload}
              type="button"
              className="btn btn-outline-primary"
            >
              Upload
            </button>
          </div>
        </div>

        <div className="table-responsive">
          <table className="prompts-list table table-sm">
            <thead>
              <tr>
                <th>Name</th>
                <th>Text</th>
              </tr>
            </thead>
            <tbody>{topics.map(this.renderRow)}</tbody>
          </table>
        </div>
      </div>
    );
  }

  private renderRow = (topic: Topic) => {
    const { id, name, text } = topic;

    return (
      <tr key={id} data-id={id}>
        <td>{name}</td>
        <td>{text}</td>
      </tr>
    );
  };

  private onInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();

    const { files } = e.currentTarget;
    if (!files) {
      return;
    }

    const file = files.item(0);
    if (!file) {
      return;
    }

    this.props.doUpload({ id: "", name: file.name }, file);
  };

  private onInputMount = (input: HTMLInputElement) => {
    this.input = input;
  };

  private onUpload = () => {
    if (!this.input) {
      return;
    }

    this.input.click();
  };
}

export const TopicsContainer = connect(
  ({ topics }: RootState) => ({
    topics: topics.list.map(k => topics.data[k]),
  }),
  dispatch => ({
    doUpload: (topic: Topic, file: File) =>
      dispatch<any>(createTopic(topic, file)),
    refresh: () => dispatch<any>(listTopics()),
  })
)(TopicsPage);

export default TopicsContainer;



// WEBPACK FOOTER //
// ./src/pages/TopicsPage.tsx